/**
 * @generated SignedSource<<1e53f65bc28b034a67ed0583f9138d76>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type BookingStatus = "CONFIRMED" | "DRAFT";
export type CalendarStartDay = "MONDAY" | "SUNDAY";
export type FacilityType = "DINING" | "GOLF_COURSE" | "RACQUET" | "SIMULATOR";
export type RequestRecurrenceEndCondition = "AFTER_OCCURRENCES" | "ON_DATE";
export type RequestRecurrenceType = "DAY" | "MONTH" | "WEEK";
import { FragmentRefs } from "relay-runtime";
export type RecurringRequestSeriesCard_booking$data = {
  readonly __typename: string;
  readonly bookingSeries: {
    readonly bookings: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly startSlot: {
            readonly agenda: {
              readonly date: string;
            };
          } | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly effectiveEndDate: string | null | undefined;
    readonly endCondition: RequestRecurrenceEndCondition | null | undefined;
    readonly id: string;
    readonly recurrenceType: RequestRecurrenceType | null | undefined;
    readonly repeatInterval: number | null | undefined;
    readonly requestedOccurrenceCount: number | null | undefined;
  } | null | undefined;
  readonly id: string;
  readonly ownerClient: {
    readonly id?: string;
  } | null | undefined;
  readonly request?: {
    readonly maxTime: string;
    readonly minTime: string;
    readonly requestCoursePreferences: ReadonlyArray<{
      readonly course: {
        readonly id: string;
        readonly name: string;
      } | null | undefined;
      readonly courseBucket: {
        readonly id: string;
        readonly name: string;
      } | null | undefined;
      readonly index: number;
    }>;
    readonly time: string;
  } | null | undefined;
  readonly seriesCount?: number | null | undefined;
  readonly startSlot: {
    readonly __typename: string;
    readonly agenda: {
      readonly date: string;
      readonly facility: {
        readonly club: {
          readonly calendarStartDay: CalendarStartDay;
          readonly supportsPrivate: boolean;
          readonly supportsPublic: boolean;
        } | null | undefined;
        readonly courses: {
          readonly count: number;
        } | null | undefined;
        readonly patronRecurringRequestMaximumEndDate: string | null | undefined;
        readonly privateBookingPermissionSet: {
          readonly membersCanMakeRecurringRequests: boolean | null | undefined;
        } | null | undefined;
        readonly type: FacilityType;
        readonly " $fragmentSpreads": FragmentRefs<"useFacilityCourseNoun_facility">;
      };
    };
  } | null | undefined;
  readonly status?: BookingStatus;
  readonly " $fragmentType": "RecurringRequestSeriesCard_booking";
};
export type RecurringRequestSeriesCard_booking$key = {
  readonly " $data"?: RecurringRequestSeriesCard_booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"RecurringRequestSeriesCard_booking">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v2 = [
  (v0/*: any*/)
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "date",
  "storageKey": null
},
v4 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RecurringRequestSeriesCard_booking",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "ownerClient",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": (v2/*: any*/),
          "type": "Member",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v2/*: any*/),
          "type": "Customer",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "startSlot",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Agenda",
          "kind": "LinkedField",
          "name": "agenda",
          "plural": false,
          "selections": [
            (v3/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Facility",
              "kind": "LinkedField",
              "name": "facility",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "useFacilityCourseNoun_facility"
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Club",
                  "kind": "LinkedField",
                  "name": "club",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "calendarStartDay",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "supportsPrivate",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "supportsPublic",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "type",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CourseConnection",
                  "kind": "LinkedField",
                  "name": "courses",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "count",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "patronRecurringRequestMaximumEndDate",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PrivateBookingPermissionSet",
                  "kind": "LinkedField",
                  "name": "privateBookingPermissionSet",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "membersCanMakeRecurringRequests",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Request",
          "kind": "LinkedField",
          "name": "request",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "time",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "minTime",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "maxTime",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RequestCoursePreference",
              "kind": "LinkedField",
              "name": "requestCoursePreferences",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "index",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Course",
                  "kind": "LinkedField",
                  "name": "course",
                  "plural": false,
                  "selections": (v4/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CourseBucket",
                  "kind": "LinkedField",
                  "name": "courseBucket",
                  "plural": false,
                  "selections": (v4/*: any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "seriesCount",
          "storageKey": null
        }
      ],
      "type": "StandardBooking",
      "abstractKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BookingSeries",
      "kind": "LinkedField",
      "name": "bookingSeries",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "recurrenceType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "repeatInterval",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endCondition",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "effectiveEndDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "requestedOccurrenceCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 366
            },
            {
              "kind": "Literal",
              "name": "orderBy",
              "value": [
                {
                  "direction": "DESC",
                  "field": "DATE_TIME"
                }
              ]
            }
          ],
          "concreteType": "BookingConnection",
          "kind": "LinkedField",
          "name": "bookings",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "BookingEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "startSlot",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Agenda",
                          "kind": "LinkedField",
                          "name": "agenda",
                          "plural": false,
                          "selections": [
                            (v3/*: any*/)
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "bookings(first:366,orderBy:[{\"direction\":\"DESC\",\"field\":\"DATE_TIME\"}])"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};
})();

(node as any).hash = "31188ea710069187d658d5a765986751";

export default node;
